import { render, staticRenderFns } from "./MerchProductCard.vue?vue&type=template&id=8ab85c56"
import script from "./MerchProductCard.vue?vue&type=script&lang=js"
export * from "./MerchProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports